import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Intro from './Intro';
import GalleryPage from './GalleryPage';
import About from './About';
import Contact from './Contact';
import Privacy from './Privacy';
import CookieBanner from './CookieBanner';
import GlobalLogo from './GlobalLogo';
import { LanguageProvider } from './LanguageContext';
import {
  loadTravelImages,
  loadPortraitsImages,
  loadStreetImages,
} from './galleryImages';

// header-backdrop has to know which route it's on to skip itself on
// /about, and useLocation only works inside the Router tree - App
// itself renders <BrowserRouter>, so it can't call useLocation directly.
// This small inner component is what actually needs the route.
function AppShell() {
  const location = useLocation();
  const isAbout = location.pathname === '/about';

  return (
    <>
      {!isAbout && <div className="header-backdrop" aria-hidden="true" />}
      <GlobalLogo />
      <Routes>
        <Route path="/" element={<Intro />} />
        <Route
          path="/travel"
          element={<GalleryPage title="Travel" images={loadTravelImages()} />}
        />
        <Route
          path="/portraits"
          element={
            <GalleryPage title="Portraits" images={loadPortraitsImages()} />
          }
        />
        <Route
          path="/street"
          element={<GalleryPage title="Street" images={loadStreetImages()} />}
        />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/privacy" element={<Privacy />} />
      </Routes>
      <CookieBanner />
    </>
  );
}

export default function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <AppShell />
      </BrowserRouter>
    </LanguageProvider>
  );
}